import { Controller } from "@hotwired/stimulus"

// Shows a sticky bottom bar after the user has scrolled 80% down the page.
// Dismisses on button click and stores the decision in sessionStorage so it
// doesn't reappear during the same browser session.
export default class extends Controller {
  connect() {
    if (sessionStorage.getItem("rate-nudge-dismissed")) {
      return
    }

    this.onScroll = this.checkScroll.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  checkScroll() {
    const scrolled = window.scrollY + window.innerHeight
    const total = document.documentElement.scrollHeight
    if (scrolled >= total * 0.8) {
      this.element.classList.remove("translate-y-full", "opacity-0", "pointer-events-none")
      window.removeEventListener("scroll", this.onScroll)
    }
  }

  dismiss() {
    this.element.classList.add("translate-y-full", "opacity-0", "pointer-events-none")
    sessionStorage.setItem("rate-nudge-dismissed", "1")
  }
}
